<template>
    <button class="previous secondary" @click="openPreviousPanel()">{{ text }}</button>
</template>

<script>
    export default {
        name: 'PreviousButton',
        props: {
            text: {
                type: String,
                default: 'Vorige'
            }
        },
        data() {
            return {
                componentNames: []
            }
        },
        methods: {
            openPreviousPanel() {
                let components = this.$parent.$parent.$options.components;
                this.componentNames = Object.values(components).map(component => (component.name));

                let i = this.componentNames.indexOf(this.$store.state.panel.current);

                this.$store.dispatch(
                    'SetPanel',
                    this.componentNames[--i]
                )
            },
        }
    }
</script>